<script>
import { format } from "@/libs/date.format";
import getDatesRange from "@/mixins/getDatesRange";
import NewSummary from "@/components/NewSummary";
import { getAgesString } from "../../../libs/ages.helper.js";
import { getEventsAmount as returnEventsAmount } from "@/components/methods";

export default {
    name: "SimpleEventSummary",
    props: {
        actData: {
            type: Object,
            default: () => {
            },
        },
        dates: {
            type: Object,
            default: () => {
            },
        },
        times: {
            type: Object,
            default: () => {
            },
        },
        repeat: {
            type: String,
            default: "",
        },
        price: {
            type: Object,
            default: () => {
            },
        },
        addHoliday: {
            type: String,
            default: "",
        },
        holidays: {
            type: Array,
            default: () => [],
        },
        priceV2: Object,
    },
    mixins: [getDatesRange],
    components: { NewSummary },
    data() {
        return {
            fullWeekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        };
    },
    methods: {
        formatDate(date) {
            if (date?.plain === undefined) {
                return "";
            }

            const day = new Date(date.plain).getDay();
            return `${this.fullWeekdays[day]} ${format(date.plain, "dS mmmm yyyy")}`;
        },

        edit(type) {
            if (type === "details") {
                this.$router.push({ name: "Add event to venue" });
            }

            if (type === "date-time") {
                this.$router.push({ name: "Add dates" });
            }

            if (type === "price") {
                this.$router.push({ name: "Add pricing" });
            }

            if (type === "holidays") {
                this.$storage.setStorageSync("addHoliday", "yes");
                this.$router.push({ name: "Add holidays" });
            }

            if (type === "booking-settings") {
                this.$router.push({ name: "Booking settings" });
            }
        },
    },
    computed: {
        getHolidays() {
            return this.holidays.map((h) => ({
                start: this.formatDate(h.start),
                end: this.formatDate(h.end),
                oneDay: h.oneDay,
            }));
        },

        getAgesForNewSummary() {
            if (this.actData.ages !== undefined) {
                return getAgesString(this.actData.ages);
            }

            return "";
        },

        getImg() {
            const images = this.$storage.getStorageSync("imgData");
            if (images === undefined) {
                return "";
            }

            const currentImg = images.find((el) => el.imgId === this.actData.img);

            return currentImg?.imgUrl;
        },

        getAllEventsAmount() {
            return returnEventsAmount(
                new Date(this.dates.start?.plain),
                new Date(this.dates.end?.plain),
                this.repeat,
                this.holidays,
            );
        },

        getEventsAmount() {
            const amount = this.getAllEventsAmount;

            if (amount === "") {
                return "";
            }

            return `${amount} ${
                this.actData.eventType.name?.toLowerCase()
                || this.actData.eventType.toLowerCase()
            } dates`;
        },

        getDates() {
            return {
                start: this.formatDate(this.dates.start),
                end: this.formatDate(this.dates.end),
                startRaw: this.dates.start,
                endRaw: this.dates.end,
                repeat: this.repeat,
            };
        },
    },
};
</script>

<template>
    <h2>Summary</h2>
    <div class="events-amount">{{ getEventsAmount }}</div>

    <NewSummary
        :activity="actData"
        :img="getImg"
        :mainCategory="actData.primaryCategory?.name "
        :secondaryCategory="actData.secondaryCategories?.name"
        :ages="getAgesForNewSummary"
        :dates="getDates"
        :times="times"
        :holidays="getHolidays"
        :addHoliday="addHoliday"
        :price="{
            freeTrial: price.freeTrial?.charAt(0).toUpperCase() + price.freeTrial?.slice(1),
            price: price.priceData?.price,
            pricePerTerm: price.priceData?.pricePerTerm,
            freePricing: price.freePricing
        }"
        :force-show-holidays="true"
        :priceV2="priceV2"
        @edit-click="edit($event)"
        :allEventsAmount="getAllEventsAmount"
    />

</template>

<style scoped>
.events-amount {
    color: #636066;
    margin-bottom: 3rem;
    font-weight: 600;
}
</style>
